import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Android = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 23.5"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
    >
      <g id="android_2_" transform="translate(-3 -.5)">
        <path
          id="Path_15696"
          d="M15.281 2.98l1.135-1.7a.5.5 0 1 0-.832-.554L14.4 2.5a5.978 5.978 0 0 0-4.8 0L8.416.723a.5.5 0 0 0-.832.554l1.135 1.7A5.992 5.992 0 0 0 6 8h12a5.992 5.992 0 0 0-2.719-5.02z"
        />
        <path
          id="Path_15697"
          d="M6 19a1 1 0 0 0 1 1h1v3a1 1 0 0 0 2 0v-3h4v3a1 1 0 0 0 2 0v-3h1a1 1 0 0 0 1-1V9H6z"
        />
        <path id="Path_15698" d="M4 9a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1z" />
        <path id="Path_15699" d="M20 9a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1z" />
      </g>
    </svg>
  );
};

Android.displayName = 'Android';
